import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getSubscriptionStatus, createCheckout, getCustomerPortalUrl } from "@/api";

export const useSubscription = () =>
  useQuery({
    queryKey: ["subscription"],
    queryFn: getSubscriptionStatus,
  });

export const useCreateCheckout = () => {
  return useMutation({
    mutationFn: async ({ variantId, redirectUrl }: { variantId: string; redirectUrl?: string }) => {
      const { url } = await createCheckout(variantId, redirectUrl);
      return url;
    },
  });
};

export const useCustomerPortal = () => {
  return useMutation({
    mutationFn: async () => {
      const { url } = await getCustomerPortalUrl();
      return url;
    },
  });
};

export const useRefreshAfterUpgrade = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["subscription"] });
    queryClient.invalidateQueries({ queryKey: ["accounts"] });
  };
};
